/* eslint-disable */
import LazyLoad from './../lazyload.min.js';
export default {
  init() {
      $(document).ready(function() {

          //Menu mobile
          var burger = $('.menu-mobile-actions');
          var menuMobile = $('.menu-mobile');
          var body = $('body');

          burger.click(function(){
            if(burger.hasClass('action--close')){
              burger.removeClass('action--close');
              menuMobile.removeClass('menu-mobile--open');
              body.removeClass('menu-mobile-open');
            }
            else{
              burger.addClass('action--close');
              menuMobile.addClass('menu-mobile--open');
              body.addClass('menu-mobile-open');
            }
          })

          //Spinner
          var submit = $('.tnp-field-button');
          submit.append('<div class="loading-spinner"></div>');
          var container = $('.tnp-subscription');
          container.append( '<div class="newsletter-response"></div>' );
          var responseMessage =  $('.newsletter-response');

          //Ajax
          var request;
          $(".tnp-subscription form").on("submit", function( event ) {
                event.preventDefault();
                responseMessage.empty();

              if ( request ) {
                  request.abort();
              }
              var
                  $form = $(this),
                  serializedData = $form.serialize(),
                  spinner = $('.loading-spinner'),
                  containerSubmit = $('.tnp-field-button'),
                  submit = $('.tnp-submit');

              spinner.addClass('show');
              submit.css('display', 'none');

              request = $.ajax({
                  url: hydrogen.homeurl+'/?na=ajaxsub',
                  method: 'POST',
                  data : serializedData,
              }).done(function(response){
                  responseMessage.append(response);
                  spinner.removeClass('show');
                  submit.css('display', 'block');
              })
              .fail(function(response){
                responseMessage.append('<p>Veuillez réessayer plus tard</p>');
                spinner.removeClass('show');
                submit.css('display', 'block');
              });

          });

          var video_wrapper = $('.youtube-video-place');
          if(video_wrapper.length){
              $('.play-youtube-video').on('click', function(){
                  video_wrapper.html('<iframe width="420" height="315" allowfullscreen frameborder="0" src="' + video_wrapper.data('yt-url') + '"></iframe>');
              });
          }

          // //Guest Slider
          // guestSlider();

          // $(window).resize(function(){
          //   guestSlider();
          // })

          // function guestSlider(){
          //   $('#guests.active').slick({
          //     slidesToShow: 1,
          //     mobileFirst: true,
          //     centerMode: true,
          //     centerPadding: '60px',
          //     arrows: false,
          //     responsive: [
          //       {
          //         breakpoint: 767,
          //         settings: "unslick"
          //       }
          //     ]
          //   });
          // }

          var blockForumText = $('.block-forum .text');
          var blockForumSubtext = $('.block-forum .subtext');
          var blockForumLink = $('.block-forum .link');

          if(blockForumText.height() > 78 ){
            blockForumText.addClass('hide');
            blockForumSubtext.addClass('hide');
            blockForumLink.addClass('visible');
          }

          blockForumLink.click(function(){
            if($(this).parent().children('.block-forum .text').hasClass('hide')){
              $(this).parent().children('.block-forum .text').removeClass('hide');
              $(this).parent().children('.block-forum .subtext').removeClass('hide');
              $(this).parent().children('.block-forum .link').removeClass('visible');
            }
          })


          var exhibitorLink = $('.guest .link');

          exhibitorLink.click(function(){
              $(this).parent().children('.guest .text').removeClass('hide');
              $(this).parent().children('.guest .link').addClass('visible');
          })



        var menuEl = document.getElementById('menu-mobile');
        var mlmenu = new MLMenu(menuEl, {
            breadcrumbsCtrl : true, // show breadcrumbs
            initialBreadcrumb : '<img src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI4IiBoZWlnaHQ9IjEyIiB2aWV3Qm94PSIwIDAgOCAxMiI+CiAgICA8cGF0aCBmaWxsPSIjRkZGIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik03LjQgMS40TDYgMCAwIDZsNiA2IDEuNC0xLjRMMi44IDZ6Ii8+Cjwvc3ZnPgo=" />', // initial breadcrumb text
        });

        //Lazy load
        const lazyContent = new LazyLoad({
          elements_selector: "img.lazy",
          use_native: true
        });

        const lazyBackground = new LazyLoad({
          elements_selector: "iframe.lazy, video.lazy, div.lazy"
        });

        lazyContent.update();
        lazyBackground.update();

      });

      // Intervenants
      $('.speaker .more').click(function(){
        $('.speaker .bio').fadeOut();
        $(this).parent().parent().addClass('speaker-active');
        $('+ .bio', this).fadeIn();
      })

      $('.speaker .close').click(function(){
        $(this).parent().parent().removeClass('speaker-active');
          $(this).parent().fadeOut();
      })

      // Vidéothèque
      function playVideo(){
        $('.template-video .video-item').click(function(e){
          e.preventDefault();
          $(window).scrollTop($('#video-player').offset().top);
          $('.video-player').addClass('video-active');
          var videoURL = $('iframe', this).attr('src');
          $('.video-player iframe')[0].src = videoURL + '?autoplay=1';
          var videoTitle = $('h2', this).text();
          $('.title-player span').html(videoTitle);
          $(this).addClass('is-playing');
        });
      }

      $('.template-video .video-player').click(function(e){
        e.preventDefault();
        $(this).addClass('video-active');
        $('iframe', this)[0].src += '?autoplay=1';
      });

      playVideo();

      // Vidéothèque filter
      $('.nav-filter').slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        // centerMode: true,
        // centerPadding: '5%',
        variableWidth: true,
        infinite: false,
        arrows: false,
      });

      $('.nav-filter .link').click(function(){
        $('.nav-filter .link').not(this).removeClass('link-active');
        $(this).addClass('link-active')
      })

      var filter = 'all';
      var page = 1;

      $('.btn-more').click(function(){
        $(this).attr("disabled","disabled");
        if($('.nav-filter .link-active').data('filter') != '') {
          filter = $($('.nav-filter .link-active')).data('filter');
        }
        refreshArticle();
      })

      $('.nav-filter .link').click(function (event) {
        event.preventDefault();
        filter = $(this).data('filter');
        $('.video-list-wrapper').empty();
        $('.actions').hide();
        refreshArticle();
      });

      function refreshArticle(){
        $('.video-list-wrapper').addClass('loading');
        $.ajax({
          url: hydrogen.ajaxurl,
          method: "POST",
          dataType: "json",
          data:
            {
              action: "getPost",
              filter: filter,
              security: hydrogen.ajax_nonce,
              page: page
            }
        })
        .done(function( data ) {
          $('.video-list-wrapper').removeClass('loading');
          if(data.items != '') {
            // history.pushState({}, '', $('.actions .btn').data('href')+'page/'+page+'/');
            $('.video-list-wrapper').append(data.items);
            playVideo();
          }
          if(data.more == 'yes') {
              page ++;
              $('.actions').show();
              $('.actions .btn').removeAttr("disabled");
              $('.actions .btn').data('pagination',page);
              // $('.action .btn').prop('href',$('.actions .btn').data('href')+'page/'+page+'/');
          }
          else {
              $('.actions').hide();
          }
        });
      }
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};

/* eslint-enable */



// WEBPACK FOOTER //
// ./scripts/routes/common.js